import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {FormGroup, FormBuilder, FormControl, Validators} from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { REGEX } from 'src/app/constants/regex';
import { CorporateService, HttpService, UtilityService } from 'src/app/services';
import { reduce } from 'rxjs-compat/operator/reduce';
import { LoginErrorComponent } from 'src/app/components/global-dialog/auth-dialog/login-error/login-error.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @Input() successMessage: string = '';
  isLoading: boolean = false;
  myModel = true;
  hide = true;
  listItem;
  flightUserData;
  loginForm: FormGroup;
  signUp: FormGroup;
  constructor(private fb: FormBuilder, private router: Router,
    private route: ActivatedRoute, private http: HttpService, private util: UtilityService, private snackbar: MatSnackBar, public dialog: MatDialog, public COPT: CorporateService ) { }

  ngOnInit(): void {
    this.loginForm = this.fb.group ({
      email: new FormControl('', [Validators.required, Validators.pattern(REGEX.EMAIL)]),
      password: new FormControl('', Validators.required),
    });
  }

  onSubmit(){
    if (this.loginForm.valid) {
      this.isLoading = true;
      this.http.flightsave(`apiV2/auth/login`, this.loginForm.value).subscribe(res => {
        if(res.statusCode === 200) {
          localStorage.setItem('Auth_Key' , res.data.token);
          localStorage.setItem('user_name' , res.data.name);
          localStorage.setItem('Flight_User_Detiles' , JSON.stringify(res.data));
          this.isLoading = false;
          window.location.pathname === "/signIn" 
          ? this.router.navigate(['u/']) 
          : (this.dialog.closeAll(), 
            this.router.navigateByUrl(`u/${window.location.pathname}`, { skipLocationChange: true })
            .then(() => this.router.navigate([`u/${window.location.pathname}`]))
          );
        }
      }, err => {
        this.isLoading = false;
        this.listItem = err?.error?.message;
        this.util.errorMessage(err);
        this.dialog.closeAll();
        this.dialog.open(LoginErrorComponent, {
          data: this.listItem,
          width: '420px',
          panelClass: 'login-dialog-container'
        });
        // localStorage.clear()
      });
      // this.http.hotelsave(`auth/user-login`, this.loginForm.value).subscribe(res => {
      //   if(res.statusCode === 200) {
      //     localStorage.setItem('Hotel_Auth_Key' , res.data.user_detail.auth_key);
      //     localStorage.setItem('User_detiles', JSON.stringify(res.data.user_detail));
      //     this.http.flightsave(`apiV2/auth/login`, this.loginForm.value).subscribe(res => {
      //       if(res.statusCode === 200) {
      //         localStorage.setItem('Auth_Key' , res.data.token);
      //         localStorage.setItem('user_name' , res.data.name);
      //         localStorage.setItem('Flight_User_Detiles' , JSON.stringify(res.data));
      //         this.router.navigate(['u/']);
      //         this.util.showMsg('Successfully');
      //       }
      //     }, err => {
      //       this.listItem = err?.error?.message;
      //       this.util.errorMessage(err);
      //       this.dialog.open(LoginErrorComponent, {
      //         data: this.listItem,
      //         width: '420px',
      //         panelClass: 'login-dialog-container'
      //       });
      //       localStorage.clear()
      //     });
      //   }
      // }, err => {
      //   this.http.flightsave(`apiV2/auth/login`, this.loginForm.value).subscribe(res => {
      //     if(res.statusCode === 200) {
      //       localStorage.setItem('Flight_User_Detiles' , JSON.stringify(res.data));
      //       this.signUp = this.fb.group({
      //         name: res.data.name,
      //         email: res.data.email,
      //         mobile: res.data.mobile,
      //         password: this.loginForm.value.password,
      //         repeat_password: this.loginForm.value.password,
      //       });
      //       this.http.hotelsave(`auth/user-registration`, this.signUp.value).subscribe(res => {
      //         if(res.statusCode === 200) {
      //           this.http.hotelsave(`auth/user-login`, this.loginForm.value).subscribe(res => {
      //             if(res.statusCode === 200) {
      //               this.flightUserData = JSON.parse(localStorage.getItem('Flight_User_Detiles')!);
      //               localStorage.setItem('Hotel_Auth_Key' , res.data.user_detail.auth_key);
      //               localStorage.setItem('Auth_Key' , this.flightUserData.token);
      //               localStorage.setItem('user_name' , this.flightUserData.name);
      //               this.router.navigate(['u/']);
      //               this.util.showMsg('Successfully Login');
      //             }
      //           }, err => {
      //             this.listItem = err?.error?.message;
      //             this.util.errorMessage(err);
      //             localStorage.clear();
      //           })
      //           this.util.showMsg('Successfully Created')
      //         }
      //       }, err => {
      //         this.listItem = err?.error?.message;
      //         this.util.errorMessage(err);
      //         this.dialog.open(LoginErrorComponent, {
      //           data: this.listItem,
      //           width: '420px',
      //           panelClass: 'login-dialog-container'
      //         });
      //         localStorage.clear();
      //       });
      //     }
      //   }, err => {
      //     this.listItem = err?.error?.message;
      //     this.util.errorMessage(err);
      //     this.dialog.open(LoginErrorComponent, {
      //       data: this.listItem,
      //       width: '420px',
      //       panelClass: 'login-dialog-container'
      //     });
      //   })
      // });
    }
  }
  forgotPassword() {
    const path = this.COPT.isCorporateUser()
      ? ['../forgot-password']
      : ['../../forgot-password'];
    this.router.navigate(path, { relativeTo: this.route });
    this.dialog.closeAll();
  }
}
